import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyCgQRgEbWtD8YdAB7ibPlhEO7bjWYG4o60',
  authDomain: 'amia-baseline-survey.firebaseapp.com',
  projectId: 'amia-baseline-survey',
  storageBucket: 'amia-baseline-survey.appspot.com',
  messagingSenderId: '911552969045',
  appId: '1:911552969045:web:51ac29e0c0ae77b43097dc',
}

const app = initializeApp(firebaseConfig)

const auth = getAuth()
const db = getFirestore(app)

export { app, auth, db }
